import BookAnAppointment from "./BookAnAppointmentContainer";

export default BookAnAppointment;
